import BrandList, { BrandListLoadState } from './BrandList';
import PersonaControlViewState from './PersonaControlViewState';
import { ObservableMap } from 'mobx';

export enum LivePersonaCardInitializationState {
    NotInitialized = 'NotInitialized',
    Initializing = 'Initializing',
    Initialized = 'Initialized',
    Failed = 'Failed',
}

interface PersonaControlStore {
    viewStates: ObservableMap<string, PersonaControlViewState>;
    livePersonaCardInitializationStatus: {
        state: LivePersonaCardInitializationState;
        timestamp: number;
    };
    // TODO: Retire isLivePersonaCardInitialized once consumers switch to livePersonaCardInitializationStatus
    isLivePersonaCardInitialized: boolean;
    isPersonaCardDisabled: boolean;
    brandList: BrandList;
    brandListLoadState: BrandListLoadState;
}

export default PersonaControlStore;
